module.exports = __webpack_public_path__ + "img/undraw_the_world_is_mine_nb0e.915de248.svg";